export enum WarehouseItemWorkRequestRejectionReason {
  NoProduct = "no_product",
  NoInstructions = "no_instructions",
  ItemUnavailable = "item_unavailable",
  Other = "other",
}
